module.exports = __webpack_public_path__ + "static/media/3_message.01bf04bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/3_message.svg
// module id = 2171
// module chunks = 0